module.exports = __webpack_public_path__ + "static/media/numbers-123.0d941a8f.svg";